:host {
  display: block;
}

.text {
  font-family: var(--primary-font);
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  box-sizing: border-box;

  .headline {
    margin-bottom: 20px;
  }

  .text-col {
    display: grid;
    gap: 20px;
    margin-bottom: 20px;
    grid-template-columns: 1fr;

    @media(min-width: 1024px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  ::slotted(.headline) {
    font-size: 20px;
    line-height: 27px;
    
    @media(max-width: 767px) {
      text-align: center;
    }
  }

  .links {
    @media (min-width: 1024px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 20px;
      grid-template-areas: ". . link";
    }
  }

  ::slotted(.link) {
    grid-area: link;
  }
}
